import Loader from "../../utils/Loader/Loader";
import Table from "../Tables/Table";
const AgencyBillingPlanTable = ({
  tableData,
  columns,
  fetch,
  loading,
  tabName,
  tableName,
}) => {
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Table
          fetch={fetch}
          columns={columns}
          data={tableData}
          table={tableName}
        />
      )}
    </>
  );
};

export default AgencyBillingPlanTable;
